export enum CBTProgramWeekThreeStep {
    WhatPurposeHaveEmotionsStep = 'what-purpose-have-emotions-served-to-you',
    TheLifecycleOfAnEmotionStep = 'the-lifecycle-of-an-emotion',
    TheExperienceOfAnEmotionStep = 'the-experience-of-an-emotion',
    WhereDoEmotionsStartStep = 'where-do-emotions-start',
    TheConsequencesStep = 'the-consequences-of-a-response',
    TheLifecycleOfYourEmotionStep = 'the-lifecycle-of-your-emotion',
    TheStartOfAnEmotionStep = 'start-of-an-emotion',
    UnderstandYourEmotionStep = 'understand-your-emotion',
    MoreAboutEmotionsStep = 'more-about-emotions',
}

export enum CBTProgramWeekThreeSurvey {
    WhatPurposeHaveEmotions = 'week-3-what-purpose-have-emotions',
    TheStartOfAnEmotion = 'week-3-start-of-an-emotion',
    UnderstandYourEmotion = 'week-3-lifecycle-of-your-emotion',
}
